import env from '@maui-mf/env'
import { api as experiments } from '@maui-mf/experiments'

const vtUIRoot = env.VIRUSTOTAL_UI_ROOT
const featureName = env.FEATURE_GTI_UX
const featureDefined = !!featureName

export const wantsFeature = user => {
  return user?.isGTI || !!(featureDefined && experiments.isEnabled(featureName))
}

export const grantedFeature = (user, features = {}) => {
  return user?.isGTI || !!(featureDefined && features[featureName])
}

export const assertLoadable = (user, features = {}) => {
  if (!wantsFeature(user) || grantedFeature(user, features)) {
    return true
  }

  if (featureDefined) {
    experiments.disable(featureName)
  }
  window.location.reload()
  return false
}

export const shouldOverrideSession = store => {
  const { isGTI = false, claims } = store?.getValue() || {}
  const isLoggedIn = !!claims
  const vtOrigin = new URL(vtUIRoot).origin
  const isGTIReferred = !!document.referrer?.includes(vtOrigin)

  return isLoggedIn && !isGTI && isGTIReferred
}
